<template>
	<div>
		<modalconfirm supplier ref="modalApprovalPO" @action="proccessPO"></modalconfirm>
		<div class="text-h5">Approval Pemesanan</div>
		<v-card class="mt-3" outlined>
			<v-card-text>
				<v-form>
					<v-row>
						<v-col cols="12" sm="4" md="4">
							<v-autocomplete item-value="po_code" hide-details @change="getDetail(po_code)" v-model="po_code" :items="OptionPO" label="Kode Pemesanan" :error-messages="responseError.po_id" @focus="responseError.po_id = ''" outlined dense color="cyan darken-2" no-data-text="Belum ada data tersedia" :filter="customFilter">
								<template v-slot:item = {item}>
									{{item.po_code}} - {{item.warehouse_name}}
								</template>
								<template v-slot:selection = {item}>
									{{item.po_code}}
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" v-if="Object.keys(detailPO).length > 0">
							<div class="font-weight-bold">Detail Warehouse</div>
							<v-row>
								<v-col cols="12" sm="3" md="3">
									<div class="d-flex">
										<v-icon>mdi-warehouse</v-icon>
										<div class="pl-3">{{ detailPO.warehouse_name }}</div>
									</div>
								</v-col>
								<v-col cols="12" sm="3" md="3">
									<div class="d-flex">
										<v-icon>mdi-phone</v-icon>
										<div class="pl-3">{{ detailPO.warehouse_mobilephone }}</div>
									</div>
								</v-col>
								<v-col cols="12" sm="6" md="6">
									<div class="d-flex">
										<v-icon class="icon-align-top">mdi-map-marker</v-icon>
										<div class="pl-3">{{ addresText }}</div>
									</div>
								</v-col>
							</v-row>
							<div class="font-weight-bold">Catatan : {{ detailPO.po_note ? detailPO.po_note : '-'}}</div>
						</v-col>

						<v-col cols="12" class="pt-0">
							<div class="font-weight-bold">Data Produk</div>
							<v-data-table dense disable-pagination :headers="headers" :items="detailPO.po_detail" hide-default-footer class="mt-2" no-data-text="Belum ada data tersedia">
								<template v-slot:item.product_name="{ item }">
									<div class="pt-2">{{ item.po_detail_supplier_product_name }}</div>
								</template>
								<template v-slot:item.product_code="{ item }">
									<div class="pt-2">{{ item.po_detail_supplier_product_code }}</div>
								</template>
								<template v-slot:item.quantity="{ item }">
									<div class="pt-2">{{ item.po_detail_quantity_approved | toNumber }} {{ item.po_detail_product_unit }}</div>
								</template>
							</v-data-table>
						</v-col>

						<v-col class="mt-2" cols="12" v-if="Object.keys(detailPO).length > 0">
							<div v-if="Object.values(poSchedules).length > 0">
								<div class="font-weight-bold">Jadwal Pengiriman</div>
								<v-card class="mb-5" outlined>
									<v-card-text class="schedule-list">
										<v-row>
											<v-col cols="12" sm="6" md="6" v-for="(a, index) in poSchedules" :key="index">
												<v-card class="mb-5 elevation-0" outlined >
													<v-card-title class="text-subtitle-1 font-weight-bold cyan lighten-3">
														<span class="grey--text text--darken-2">{{index | haritanggal}}</span>
													</v-card-title>
													<v-data-table dense :headers="scheduleHeaders" :items="a" hide-default-footer>
														<template v-slot:item.po_schedule_detail_quantity="{ item }">
															<div>{{ item.po_schedule_detail_quantity | toNumber }}</div>
														</template>
													</v-data-table>
												</v-card>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</div>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-3 pb-3">
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" :disabled="!po_code" outlined class="text-capitalize" @click="reject">
					<div>Tolak</div>
				</v-btn>
				<v-btn color="grey darken-1" v-if="!po_code" disabled outlined class="text-capitalize">
					<div>Proses</div>
				</v-btn>
				<v-btn color="cyan darken-2" v-else dark depressed outlined class="text-capitalize" @click="approve">
					<div>Proses</div>
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			po_code: '',
			poProccess: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'po_detail_supplier_product_name', sortable: true},
			{ text: 'Kode Produk', value: 'po_detail_supplier_product_code', sortable: false},
			{ text: 'Jumlah Pesanan', value: 'quantity', sortable: false, align: 'center'},
			],
			scheduleHeaders: [
			{ text: 'Nama Produk', value: 'supplier_product_name', sortable: false, width: '50%'},
			{ text: 'Kode Produk', value: 'supplier_product_code', sortable: false, width: '30%'},
			{ text: 'Jumlah', value: 'po_schedule_detail_quantity', sortable: false, align: 'center', width: '20%'},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('poSupplier', ['detailPO', 'response', 'responseError', 'OptionPO']),
		...mapGetters('poSupplier', ['productPO']),

		poSchedules() {
			let schedule = []
			if (this.detailPO.po_schedules) {
				schedule = this.detailPO.po_schedules.reduce((r, a) => {
					r[a.po_schedule_detail_date] = [...r[a.po_schedule_detail_date] || [], a];
					return r;
				}, {});
			}
			return schedule
		},
		addresText() {
			var data = []
			if (this.detailPO) {
				if (this.detailPO.warehouse_address)
					data.push(this.detailPO.warehouse_address)
				if (this.detailPO.warehouse_subdistrict_name)
					data.push(this.detailPO.warehouse_subdistrict_name)
				if (this.detailPO.warehouse_city_name)
					data.push(this.detailPO.warehouse_city_name)
				if (this.detailPO.warehouse_province_name)
					data.push(this.detailPO.warehouse_province_name)
			}
			return data.join(', ')
		}
	},
	methods: {
		...mapActions('poSupplier', ['getDetailPO', 'approvePO', 'rejectPO', 'getOptionPOforApprove']),
		...mapMutations('poSupplier', ['setDetailPO', 'clearDataPO']),
		...mapMutations(['setOverlay']),

		getDetail(code) {
			if (code) {
				this.getDetailPO(code)
			} else {
				this.setDetailPO({})
			}
		},
		approve(){
			this.poProccess = 'approve'
			let msg = "Yakin akan memproses Pemesanan ini?"
			this.$refs.modalApprovalPO.setMessage(msg)
			this.$refs.modalApprovalPO.showConfirm()
		},
		reject(){
			this.poProccess = 'reject'
			let msg = "Yakin akan membatalkan Pemesanan ini?"
			this.$refs.modalApprovalPO.setMessage(msg)
			this.$refs.modalApprovalPO.showConfirm()
		},
		async proccessPO() {
			await this.setOverlay(true)
			await this.$refs.modalApprovalPO.hideConfirm()
			if (this.poProccess == 'approve') {
				await this.approvePO(this.detailPO.po_id).then(() => {
					if (this.response.code == 200.) {
						this.po_code = ''
						this.setDetailPO({})
						this.getOptionPOforApprove()
					}
				})
			} else if (this.poProccess == 'reject') {
				await this.rejectPO(this.detailPO.po_id).then(() => {
					if (this.response.code == 200.) {
						this.po_code = ''
						this.setDetailPO({})
						this.getOptionPOforApprove()
					}
				})
			}
			await this.setOverlay(false)
		},
		customFilter(item, queryText) {
			const textOne = item.po_code.toLowerCase()
			const textTwo = item.warehouse_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
	},
	created() {
		this.setDetailPO({})
		this.$store.dispatch('setPageTitle', `Approval Pemesanan`);
		this.getOptionPOforApprove().then(() => {
			if (this.$route.params.code) {
				this.po_code = this.$route.params.code
				this.getDetailPO(this.$route.params.code)
			}
		})
	},
	beforeDestroy() {
		this.clearDataPO()
	},
	watch: {
	}
}
</script>

<style>
.schedule-list {
	max-height: 500px;
	overflow-y: auto;
}
</style>